import TextRangeInputBase from './TextRangeInput';
export * from './TextRangeInput';
export const TextRangeInput = TextRangeInputBase;

export default TextRangeInput;
